/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getInstitutions } from 'app/entities/institution/institution.reducer';
import { getEntities as getCashTransactions } from 'app/entities/cash-transaction/cash-transaction.reducer';
import { getEntities as getInsuranceClaims } from 'app/entities/insurance-claim/insurance-claim.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getHospitalBills } from 'app/entities/hospital-bill/hospital-bill.reducer';
import { getEntities as getPackageSubscribers } from 'app/entities/package-subscriber/package-subscriber.reducer';
import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { BillOrigin } from 'app/shared/model/enumerations/bill-origin.model';
import { createEntity, getEntity, reset, updateEntity } from './hospital-payment.reducer';

export const HospitalPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const institutions = useAppSelector(state => state.institution.entities);
  const cashTransactions = useAppSelector(state => state.cashTransaction.entities);
  const insuranceClaims = useAppSelector(state => state.insuranceClaim.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const hospitalBills = useAppSelector(state => state.hospitalBill.entities);
  const packageSubscribers = useAppSelector(state => state.packageSubscriber.entities);
  const hospitalPaymentEntity = useAppSelector(state => state.hospitalPayment.entity);
  const loading = useAppSelector(state => state.hospitalPayment.loading);
  const updating = useAppSelector(state => state.hospitalPayment.updating);
  const updateSuccess = useAppSelector(state => state.hospitalPayment.updateSuccess);
  const paymentMethodValues = Object.keys(PaymentMethod);
  const paymentStatusValues = Object.keys(PaymentStatus);
  const billOriginValues = Object.keys(BillOrigin);

  const handleClose = () => {
    navigate(`/hospital-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getInstitutions({}));
    dispatch(getCashTransactions({}));
    dispatch(getInsuranceClaims({}));
    dispatch(getAdmissions({}));
    dispatch(getHospitalBills({}));
    dispatch(getPackageSubscribers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.writtenOn = convertDateTimeToServer(values.writtenOn);
    values.toRealizeOn = convertDateTimeToServer(values.toRealizeOn);
    values.realizedOn = convertDateTimeToServer(values.realizedOn);
    values.chequeDate = convertDateTimeToServer(values.chequeDate);
    if (values.paidValue !== undefined && typeof values.paidValue !== 'number') {
      values.paidValue = Number(values.paidValue);
    }
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.cardExpiryDate !== undefined && typeof values.cardExpiryDate !== 'number') {
      values.cardExpiryDate = Number(values.cardExpiryDate);
    }
    if (values.voidedDate !== undefined && typeof values.voidedDate !== 'number') {
      values.voidedDate = Number(values.voidedDate);
    }

    const entity = {
      ...hospitalPaymentEntity,
      ...values,
      insuranceOrBank: institutions.find(it => it.id.toString() === values.insuranceOrBank?.toString()),
      cashTransaction: cashTransactions.find(it => it.id.toString() === values.cashTransaction?.toString()),
      claim: insuranceClaims.find(it => it.id.toString() === values.claim?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      bill: hospitalBills.find(it => it.id.toString() === values.bill?.toString()),
      subscriber: packageSubscribers.find(it => it.id.toString() === values.subscriber?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          writtenOn: displayDefaultDateTime(),
          toRealizeOn: displayDefaultDateTime(),
          realizedOn: displayDefaultDateTime(),
          chequeDate: displayDefaultDateTime(),
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          paymentMethod: 'CASH',
          paymentStatus: 'ENTERED',
          billOrigin: 'OP',
          ...hospitalPaymentEntity,
          writtenOn: convertDateTimeFromServer(hospitalPaymentEntity.writtenOn),
          toRealizeOn: convertDateTimeFromServer(hospitalPaymentEntity.toRealizeOn),
          realizedOn: convertDateTimeFromServer(hospitalPaymentEntity.realizedOn),
          chequeDate: convertDateTimeFromServer(hospitalPaymentEntity.chequeDate),
          microSec: convertDateTimeFromServer(hospitalPaymentEntity.microSec),
          timestampEntry: convertDateTimeFromServer(hospitalPaymentEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(hospitalPaymentEntity.lastUpdated),
          insuranceOrBank: hospitalPaymentEntity?.insuranceOrBank?.id,
          cashTransaction: hospitalPaymentEntity?.cashTransaction?.id,
          claim: hospitalPaymentEntity?.claim?.id,
          admission: hospitalPaymentEntity?.admission?.id,
          bill: hospitalPaymentEntity?.bill?.id,
          subscriber: hospitalPaymentEntity?.subscriber?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospitalPayment.home.createOrEditLabel" data-cy="HospitalPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospitalPayment.home.createOrEditLabel">Create or edit a HospitalPayment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-payment-id"
                  label={translate('tinyMedicRestApp.hospitalPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.writtenOn')}
                id="hospital-payment-writtenOn"
                name="writtenOn"
                data-cy="writtenOn"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.toRealizeOn')}
                id="hospital-payment-toRealizeOn"
                name="toRealizeOn"
                data-cy="toRealizeOn"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.paymentMethod')}
                id="hospital-payment-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="select"
              >
                {paymentMethodValues.map(paymentMethod => (
                  <option value={paymentMethod} key={paymentMethod}>
                    {translate(`tinyMedicRestApp.PaymentMethod.${paymentMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.realized')}
                id="hospital-payment-realized"
                name="realized"
                data-cy="realized"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.realizedOn')}
                id="hospital-payment-realizedOn"
                name="realizedOn"
                data-cy="realizedOn"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.realizationComments')}
                id="hospital-payment-realizationComments"
                name="realizationComments"
                data-cy="realizationComments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.comments')}
                id="hospital-payment-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.chequeRefNo')}
                id="hospital-payment-chequeRefNo"
                name="chequeRefNo"
                data-cy="chequeRefNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.chequeDate')}
                id="hospital-payment-chequeDate"
                name="chequeDate"
                data-cy="chequeDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.creditCardRefNo')}
                id="hospital-payment-creditCardRefNo"
                name="creditCardRefNo"
                data-cy="creditCardRefNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.transactionRefNo')}
                id="hospital-payment-transactionRefNo"
                name="transactionRefNo"
                data-cy="transactionRefNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.paidValue')}
                id="hospital-payment-paidValue"
                name="paidValue"
                data-cy="paidValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.insuranceRefNo')}
                id="hospital-payment-insuranceRefNo"
                name="insuranceRefNo"
                data-cy="insuranceRefNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.active')}
                id="hospital-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.microSec')}
                id="hospital-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.timestampEntry')}
                id="hospital-payment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.lastUpdated')}
                id="hospital-payment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.cursor')}
                id="hospital-payment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.paymentStatus')}
                id="hospital-payment-paymentStatus"
                name="paymentStatus"
                data-cy="paymentStatus"
                type="select"
              >
                {paymentStatusValues.map(paymentStatus => (
                  <option value={paymentStatus} key={paymentStatus}>
                    {translate(`tinyMedicRestApp.PaymentStatus.${paymentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.billOrigin')}
                id="hospital-payment-billOrigin"
                name="billOrigin"
                data-cy="billOrigin"
                type="select"
              >
                {billOriginValues.map(billOrigin => (
                  <option value={billOrigin} key={billOrigin}>
                    {translate(`tinyMedicRestApp.BillOrigin.${billOrigin}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.collectedById')}
                id="hospital-payment-collectedById"
                name="collectedById"
                data-cy="collectedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.collectedByType')}
                id="hospital-payment-collectedByType"
                name="collectedByType"
                data-cy="collectedByType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.lastUpdatedById')}
                id="hospital-payment-lastUpdatedById"
                name="lastUpdatedById"
                data-cy="lastUpdatedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.gatewayVendor')}
                id="hospital-payment-gatewayVendor"
                name="gatewayVendor"
                data-cy="gatewayVendor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.accountOrCardNo')}
                id="hospital-payment-accountOrCardNo"
                name="accountOrCardNo"
                data-cy="accountOrCardNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.accountHolderName')}
                id="hospital-payment-accountHolderName"
                name="accountHolderName"
                data-cy="accountHolderName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.cardExpiryDate')}
                id="hospital-payment-cardExpiryDate"
                name="cardExpiryDate"
                data-cy="cardExpiryDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.voided')}
                id="hospital-payment-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.voidedReason')}
                id="hospital-payment-voidedReason"
                name="voidedReason"
                data-cy="voidedReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalPayment.voidedDate')}
                id="hospital-payment-voidedDate"
                name="voidedDate"
                data-cy="voidedDate"
                type="text"
              />
              <ValidatedField
                id="hospital-payment-insuranceOrBank"
                name="insuranceOrBank"
                data-cy="insuranceOrBank"
                label={translate('tinyMedicRestApp.hospitalPayment.insuranceOrBank')}
                type="select"
              >
                <option value="" key="0" />
                {institutions
                  ? institutions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-payment-cashTransaction"
                name="cashTransaction"
                data-cy="cashTransaction"
                label={translate('tinyMedicRestApp.hospitalPayment.cashTransaction')}
                type="select"
              >
                <option value="" key="0" />
                {cashTransactions
                  ? cashTransactions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-payment-claim"
                name="claim"
                data-cy="claim"
                label={translate('tinyMedicRestApp.hospitalPayment.claim')}
                type="select"
              >
                <option value="" key="0" />
                {insuranceClaims
                  ? insuranceClaims.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-payment-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.hospitalPayment.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-payment-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.hospitalPayment.bill')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalBills
                  ? hospitalBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-payment-subscriber"
                name="subscriber"
                data-cy="subscriber"
                label={translate('tinyMedicRestApp.hospitalPayment.subscriber')}
                type="select"
              >
                <option value="" key="0" />
                {packageSubscribers
                  ? packageSubscribers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/hospital-payment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalPaymentUpdate;
